import React from "react";

const TermsOfUse = () => {
  return (
    <article className="mx-auto max-w-3xl px-4 py-8 text-mauve-900">
      <h1 className="mb-6 text-center text-3xl font-semibold text-mauve-900">
        Terms of Use
      </h1>

      <p>
        <strong>Last Updated:</strong> July 21st, 2026
      </p>

      <p>
        Welcome to <strong>FaveBack</strong> (
        <a
          href="https://faveback.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://faveback.com
        </a>
        ). These Terms of Use ("Terms") govern your access to and use of the
        FaveBack website, app (
        <a
          href="https://app.faveback.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://app.faveback.com
        </a>
        ), and related services (collectively, the "Service"). By using the
        Service, you agree to be bound by these Terms. If you do not agree,
        please do not use the Service.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        1. Acceptance of Terms
      </h3>
      <p>
        By accessing or using FaveBack, you confirm that you have read,
        understood, and agree to be bound by these Terms and our Privacy Policy.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        2. Description of Service
      </h3>
      <p>
        FaveBack provides a platform for photographers to collect offline photo
        selections from their clients. Users create selection requests to
        facilitate the selection process, and clients can submit their picks
        through a dedicated request link.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        3. User Accounts
      </h3>
      <ul>
        <li>To use certain features, you must create an account.</li>
        <li>
          You are responsible for maintaining the confidentiality of your
          account credentials.
        </li>
        <li>
          You agree to provide accurate and complete information during
          registration and keep it updated.
        </li>
      </ul>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        4. Use of the Service
      </h3>
      <ul>
        <li>
          You agree to use the Service only for its intended purposes and in
          compliance with applicable laws.
        </li>
        <li>
          You must not misuse the Service, including but not limited to
          uploading unlawful or offensive content, interfering with other users,
          or attempting to gain unauthorized access.
        </li>
      </ul>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        5. Intellectual Property
      </h3>
      <ul>
        <li>
          All content and materials on FaveBack, including but not limited to
          trademarks, logos, and software, are owned or licensed by us.
        </li>
        <li>
          Users retain ownership of their uploaded content but grant FaveBack a
          limited license to store and display the content as necessary to
          provide the Service.
        </li>
      </ul>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        6. Termination
      </h3>
      <p>
        We reserve the right to suspend or terminate accounts that violate these
        Terms, at our sole discretion.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        7. Limitation of Liability
      </h3>
      <ul>
        <li>The Service is provided "as is" without warranties of any kind.</li>
        <li>
          We are not responsible for any losses, damages, or issues arising from
          your use of the Service.
        </li>
      </ul>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        8. Modifications to the Terms
      </h3>
      <p>
        We may update these Terms from time to time. Continued use of the
        Service after modifications constitutes acceptance of the revised Terms.
      </p>

      <h3 className="mt-6 text-xl font-semibold text-mauve-800">
        9. Contact Information
      </h3>
      <p>
        For any questions regarding these Terms, please contact us at{" "}
        <strong>support@faveback.com</strong>.
      </p>
    </article>
  );
};

export default TermsOfUse;
